import React, { useEffect, useState } from 'react'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs';
import moment from 'moment';
import { BarndImg, LoginPageImg } from '../../static/constant/imgConstants';
import { FiSearch } from 'react-icons/fi';
import Popup from '../../components/popups/Popup/Popup';
import { useDispatch, useSelector } from 'react-redux';
import { getWalletTxnWithFilter, getWalletTxnWithFilterReset } from '../../store/influencerCampaignStore/actions/InfluencerCampaignActions/getWalletTxnWithFilterActions';
import { addMoneyToWallet } from '../../store/influencerCampaignStore/actions/InfluencerCampaignActions/addMoneyToWalletActions';
import { useLocation, useNavigate } from 'react-router';
import { txnStatus } from '../../store/influencerCampaignStore/actions/InfluencerCampaignActions/txnStatusActions';
import { getUserInfo } from '../../store/authStore/actions/authActions/getUserInfoActions';
import { BsCopy } from 'react-icons/bs';
import { useToast } from '../../hooks/useToast';
import { payment_redirect_uri, stripe_onboarding_callback } from '../../store/constants';
import DataTable from 'react-data-table-component';
import { FaCircleExclamation } from 'react-icons/fa6';
import { stripeOnboarding } from '../../store/influencerCampaignStore/actions/InfluencerCampaignActions/stripeOnboardingAction';
import { checkStripeOnboardingStatus } from '../../store/influencerCampaignStore/actions/InfluencerCampaignActions/checkStripeOnboardingStatusActions';
import { requestPayout } from '../../store/influencerCampaignStore/actions/InfluencerCampaignActions/requestPayoutAction';
import { Oval } from 'react-loader-spinner';
import { GiWallet } from "react-icons/gi";
import Footer from '../../components/common/Footer/Footer';

const TransactionCard = ({ transaction }) => (
        <div className="bg-white rounded-lg shadow-md p-4 mb-4 border border-gray-300">
          <div className="flex flex-col space-y-3">
            {/* Only Transaction Description - Larger Font */}
            <div>
              <span style={{ fontSize: "1.6rem" }} className="font-bold">{transaction.description}</span>
              <hr className="mt-2 border-t border-gray-300" /> 
            </div>
            
            {/* Date */}
            <div className="flex items-center">
              <span style={{ fontSize: "1.4rem" }} className="font-bold w-32">Date:</span>
              <span style={{ fontSize: "1.4rem" }}>
                {moment.utc(transaction.txnDate.split("+")[0]).local().format("DD-MM-YYYY hh:mm A")}
              </span>
            </div>
            
            {/* Amount */}
            <div className="flex items-center">
              <span style={{ fontSize: "1.4rem" }} className="font-bold  w-32">Amount:</span>
              <span style={{ fontSize: "1.4rem" }} >${transaction.amount}</span>
            </div>
            
            {/* Transaction Type */}
            <div className="flex items-center">
              <span style={{ fontSize: "1.4rem" }} className="font-bold  w-32">Txn Type:</span>
              <span style={{ fontSize: "1.4rem" }}>{transaction.transactionType}</span>
            </div>
            
            {/* Balance */}
            <div className="flex items-center">
              <span style={{ fontSize: "1.4rem" }} className="font-bold  w-32">Balance:</span>
              <span style={{ fontSize: "1.4rem" }} >${transaction.balance}</span>
            </div>
          </div>
        </div>
      );

const InfluencerWalletAndTransactions = () => {
    const dispatch = useDispatch()
    const Toast = useToast()

    const [isPopupOpen, setPopupOpen] = useState(false);
    const [receiptPopupOpen, setReceiptPopupOpen] = useState(false);
    const [isOnboardingPopupOpen, setIsOnboardingPopupOpen] = useState(false);
    const [getWalletTxnWithFilterResponse, setGetWalletTxnWithFilterResponse] = useState();
    const [filteredTransaction, setFilteredTransaction] = useState([]);
    const [enteredAmount, setEnteredAmount] = useState(0);
    const [transactionDetails, setTransactionDetails] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [isMobile, setIsMobile] = useState(false);

    const getUserInfoReducer = useSelector(state => state.getUserInfoReducer);
    const requestPayoutReducerLoading = useSelector(state => state.requestPayoutReducer.loading);

    const breadcrumbData = [
        { label: 'Home', href: '/influencer' },
        { label: 'Influencer Transactions', href: '#' },
    ];

    const columns = [
        {
            name: 'Transaction',
            selector: row => row.description,
            sortable: true,
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Date',
            selector: row => moment.utc(row.txnDate.split("+")[0]).local().format("DD-MM-YYYY hh:mm A"),
            sortable: true,
            style: {
                width: '10rem',  // Adjust the width as needed
            },
        },
        {
            name: 'Amount',
            selector: row => (
                <span
                // className={`inline-block px-3 py-1 rounded-full text-center ${getStatusStyle(row.campaignStatus)}`}
                >
                    ${row.amount}
                </span>
            ),
            style: {
                width: '10rem',  // Set a smaller width for this column
            },
        },
        {
            name: 'Txn Type',
            selector: row => row.transactionType,
            style: {
                width: '10rem',  // Adjust the width for consistency
            },
        },
        {
            name: 'Balance',
            selector: row => (
                <span
                // className={`inline-block px-3 py-1 rounded-full text-center ${getStatusStyle(row.campaignStatus)}`}
                >
                    ${row.balance}
                </span>
            ),
            style: {
                width: '10rem',
            },
        },
    ];

    const customTableStyles = {
        table: {
            style: {
                position: 'relative',
            },
        },
        headRow: {
            style: {
                backgroundColor: '#F1F4F9',
                minHeight: '52px',
                fontWeight: 700,
                borderRadius: '0.4rem',
                borderBottom: 'none',
                // position: 'fixed',
                top: 0,
            },
            denseStyle: {
                minHeight: '32px',
            },
        },
        rows: {
            style: {
                fontSize: '1.4rem',  // Increased text size for rows
                fontWeight: 600,
                color: '#202224',
                borderBottom: '1px solid #EDEFF1',
                minHeight: '70px',
            },
            denseStyle: {
                minHeight: '40px',
            },
        },
        headCells: {
            style: {
                padding: '1rem',
                fontSize: '1.6rem',
                textAlign: 'left',
            },
        },
        cells: {
            style: {
                padding: '1.5rem',
            },
        },
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };



    const handleCopy = async (text) => {
        try {
            await navigator.clipboard.writeText(text); // Copy text to clipboard
            Toast('Copied to clipboard!', 'success'); // Set success message
        } catch (err) {
            Toast('Failed to copy', 'error'); // Error handling
        }
    };

    useEffect(() => {
        dispatch(getWalletTxnWithFilter({
            "fromDate": "",
            "toDate": ""
        }, (status, response, message) => {
            if (status === 200) {

                const sorted = [...response].sort((a, b) => {
                    const dateA = new Date(a.txnDate).getTime(); // Convert to timestamp
                    const dateB = new Date(b.txnDate).getTime(); // Convert to timestamp
                    return dateB - dateA; // Sort in descending order
                });

                setGetWalletTxnWithFilterResponse(sorted);
                setFilteredTransaction(sorted);
                dispatch(getWalletTxnWithFilterReset());
            } else if (status) {
                dispatch(getWalletTxnWithFilterReset());
            }
        }));
        dispatch(getUserInfo());
    }, []);

    useEffect(() => {
        if (searchQuery === '') {
            setFilteredTransaction(getWalletTxnWithFilterResponse);
        } else {
            const filtered = getWalletTxnWithFilterResponse?.filter(campaign =>
                campaign.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
                campaign.transactionType.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredTransaction(filtered);
        }
    }, [searchQuery, getWalletTxnWithFilterResponse]);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        // const sessionIdFromUrl = params.get('sessionId');
        const paymentStatusFromUrl = params.get('status');

        if (paymentStatusFromUrl) {
            // setSessionId(sessionIdFromUrl);
            console.log('Payment Status:', paymentStatusFromUrl);

            // Optionally process the status
            if (paymentStatusFromUrl === 'success') {
                console.log('Payment was successful!');
            } else if (paymentStatusFromUrl === 'failed') {
                Toast('Payment failed or was canceled.', "error");
            }

            // Clean up the URL if necessary
            navigate(location.pathname, { replace: true });

            dispatch(checkStripeOnboardingStatus({
            }, (status, response, message) => {
                if (status === 200) {
                    // Populate transaction details and open receipt popup
                    // setTransactionDetails(response);
                    // setReceiptPopupOpen(true);
                    dispatch(getUserInfo());
                    Toast(message, "success");
                } else if (status) {
                    Toast(message, "error");
                }
            }));
        }
    }, [location, navigate]);

    useEffect(() => {
            const checkScreenSize = () => {
                setIsMobile(window.innerWidth < 768); // 768px is a common breakpoint for mobile devices
            };
            
            // Initial check
            checkScreenSize();
            
            // Add event listener for window resize
            window.addEventListener('resize', checkScreenSize);
            
            // Cleanup
            return () => window.removeEventListener('resize', checkScreenSize);
        }, []);

    return (
        <div className="w-full h-full flex flex-col overflow-auto bg-[#F2F3F7]">
            <Breadcrumbs breadcrumbs={breadcrumbData} />
            <div className="w-full flex justify-between items-center py-2">
                <div className="relative px-[4rem]">
                    <FiSearch className="absolute top-1/2 left-20 transform -translate-y-1/2 w-[2.1rem] h-[2.1rem] text-gray-400" />
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        placeholder="Search Transactions"
                        className="w-[20rem] p-3 border text-[1.4rem] inter-font font-[400] border-gray-300 rounded-[0.3rem] pl-16 outline-none"
                    />
                </div>
                <div
                    className="px-[4rem] cursor-pointer"
                    onClick={() => {
                        if (getUserInfoReducer?.data?.stripeServiceAccountId) {
                            setEnteredAmount(0);
                            setPopupOpen(true);
                        } else {
                            setIsOnboardingPopupOpen(true);
                        }
                    }}
                >
                    <div className="my-5">
                        <GiWallet size={40} className="" color='#202224' />
                        <div className="text-[1.4rem] text-[#202224]">
                            Pay Out
                        </div>
                    </div>
                </div>
            </div>
            {/* Content List Table */}
            <div className="px-[4rem] w-full">
                {requestPayoutReducerLoading ?
                    <div className="flex justify-center items-center">
                        <Oval
                            visible={true}
                            height="50"
                            width="50"
                            color="#000000"
                            ariaLabel="oval-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                    </div>
                    :
                    <div className="w-full h-full flex flex-col rounded-[2.6rem] bg-[#ffffff]">
                        <div className="sticky top-0 z-10 bg-[#ffffff] p-[2.8rem]">
                            <h2 className="text-[2.4rem] inter-font font-[700]">Transaction History</h2>
                        </div>
                        <div className={`w-full ${isMobile ? 'hidden' : 'block'}`}>
                        <div className="w-full max-h-[50rem] overflow-y-auto no-scrollbar px-[2.4rem] pb-[2.4rem]">
                            {Array.isArray(filteredTransaction) && filteredTransaction?.length > 0 ? (
                                    <DataTable
                                        columns={columns}
                                        data={filteredTransaction}
                                        customStyles={customTableStyles}
                                        pagination
                                        highlightOnHover
                                        striped
                                        responsive
                                    />
                                )
                                :
                                <div className="text-4xl leading-[70px] text-gray-500 text-center mt-4">
                                    No Transactions Found.
                                </div>
                            }
                        </div>
                        </div>
                        <div className={`w-full ${isMobile ? 'block' : 'hidden'}`}>
                        <div className="w-full max-h-[50rem] overflow-y-auto no-scrollbar px-[2.4rem] pb-[2.4rem]">
                            {Array.isArray(getWalletTxnWithFilterResponse) && getWalletTxnWithFilterResponse?.length > 0 ? (
                                <div className="flex flex-col">
                                    {/* <MobileCardHeader /> */}
                                    {getWalletTxnWithFilterResponse.map((transaction, index) => (
                                        <TransactionCard key={index} transaction={transaction} />
                                    ))}
                                </div>
                            ) : (
                                <div className="text-2xl leading-[50px] text-gray-500 text-center mt-4">
                                    No Transactions Found.
                                </div>
                            )}
                        </div>
                    </div>
                        
                    </div>
                }
            </div>

            {/* Add Money Popup */}
            <Popup
                isOpen={isPopupOpen}
                onClose={() => setPopupOpen(false)}
                title="Pay Out from your Wallet"
                canDismiss
                icon={<GiWallet size={110} className="my-[5rem]" color='#202224' />}
                content={
                    <div className="">
                        <label className="text-[#111729] text-[1.4rem] mb-4">
                            Enter Digits
                        </label>
                        <input
                            type="text"
                            className="w-full px-4 py-4 text-[1.4rem] border border-gray-300 rounded-lg focus:outline-none "
                            value={enteredAmount}
                            onChange={(e) => {
                                const value = e.target.value;
                                let numericValue = value.replace(/[^0-9]/g, '');
                                numericValue = numericValue.replace(/^0+/, '');
                                setEnteredAmount(numericValue === '' ? '0' : numericValue);
                            }}
                        />
                    </div>
                }
                size="sm"
                primaryButton={{
                    text: 'Pay',
                    onClick: () => {
                        if (enteredAmount === 0) {
                            Toast("Please enter amount")
                        } else if (enteredAmount > 999999) {
                            Toast("Amount should be less than 999999");
                        } else {
                            dispatch(requestPayout({
                                "amount": enteredAmount
                            }, (status, response, message) => {
                                if (status == 200) {
                                    setTransactionDetails(response);
                                    setReceiptPopupOpen(true);
                                    dispatch(getWalletTxnWithFilter({
                                        "fromDate": "",
                                        "toDate": ""
                                    }, (status, response, message) => {
                                        if (status === 200) {
                                            setGetWalletTxnWithFilterResponse(response);
                                            dispatch(getWalletTxnWithFilterReset());
                                        } else if (status) {
                                            Toast(message, "error")
                                            dispatch(getWalletTxnWithFilterReset());
                                        }
                                    }));
                                    dispatch(getUserInfo());
                                } else if (status) {
                                    Toast(message, "error");
                                }
                            }))
                            setEnteredAmount(0);
                            setPopupOpen(false);
                        }
                    },
                }}
                secondaryButton={{
                    text: 'Cancel',
                    onClick: () => {
                        setEnteredAmount(0);
                        setPopupOpen(false);
                    },
                }}
            />

            {/* Receipt Popup */}
            <Popup
                isOpen={receiptPopupOpen}
                onClose={() => setReceiptPopupOpen(false)}
                title="Transaction Receipt"
                canDismiss
                content={
                    transactionDetails ? (
                        <div className="w-full p-4">
                            {/* Logo and Header */}
                            <div className="flex items-center justify-between mb-6 border-b pb-4">
                                <div>
                                    <img src={LoginPageImg.login1} alt="Brand Logo" className="w-[40%] h-[40%]" />
                                </div>
                                <div className="text-right">
                                    <h2 className="text-xl font-bold text-gray-800">Transaction Receipt</h2>
                                    <p className="text-[1.4rem] text-gray-500">Thank you for your transaction!</p>
                                </div>
                            </div>

                            {/* Transaction Details */}
                            <div className="flex flex-col gap-4 mb-6">
                                <div className="flex justify-start items-center">
                                    <div className='w-[60%]'>
                                        <h3
                                            className="text-[1.4rem] font-semibold text-gray-500 flex justify-start items-center cursor-pointer"
                                            onClick={() => handleCopy(transactionDetails.orderId)}
                                        >
                                            Bank Account ID:
                                            <BsCopy className="ml-[1rem]" />
                                        </h3>
                                        <p className="text-[1.4rem] text-gray-800">{transactionDetails.bankAccountId}</p>
                                    </div>
                                    <div className='w-[30%]'>
                                        <h3
                                            className="text-[1.4rem] font-semibold text-gray-500 flex justify-start items-center cursor-pointer"
                                            onClick={() => handleCopy(transactionDetails.referenceNumber)}
                                        >
                                            Reference Number:
                                            <BsCopy className="ml-[1rem]" />
                                        </h3>
                                        <p className="text-[1.4rem] text-gray-800">{transactionDetails.referenceNumber}</p>
                                    </div>
                                </div>
                                <div className="flex justify-start items-center">
                                    <div className='w-[60%]'>
                                        <h3 className="text-[1.4rem] font-semibold text-gray-500">Transaction Date:</h3>
                                        <p className="text-[1.4rem] text-gray-800">{moment(transactionDetails.transactionDate).format('DD-MM-YYYY hh:mm A')}</p>
                                    </div>
                                    <div className='w-[30%]'>
                                        <h3 className="text-[1.4rem] font-semibold text-gray-500">Status:</h3>
                                        <p className={`text-[1.4rem] ${transactionDetails.status == 'SUCCESS' ? 'text-green-600' : 'text-red-600'}`}>
                                            {transactionDetails.status}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex justify-start items-center">
                                    <div className='w-[60%]'>
                                        <h3
                                            className="text-[1.4rem] font-semibold text-gray-500 flex justify-start items-center cursor-pointer"
                                            onClick={() => handleCopy(transactionDetails.rrn)}
                                        >
                                            RRN No:
                                            <BsCopy className="ml-[1rem]" />
                                        </h3>
                                        <p className="text-[1.4rem] text-gray-800">{transactionDetails.rrn}</p>
                                    </div>
                                    <div className='w-[30%]'>
                                        <h3
                                            className="text-[1.4rem] font-semibold text-gray-500 flex justify-start items-center cursor-pointer"
                                        >
                                            Remaining Balance
                                        </h3>
                                        <p className="text-[1.4rem] text-gray-800">{transactionDetails.balance}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Amount Details */}
                            <div className="bg-gray-100 p-4 rounded-md">
                                <h3 className="text-[1.4rem] font-semibold text-gray-500">Amount:</h3>
                                <p className="text-[1.6rem] font-bold text-gray-800">${transactionDetails.amount}</p>
                            </div>

                            {/* Footer */}
                            <div className="mt-6 text-center text-[1.4rem] text-gray-500 border-t pt-4">
                                <p>If you have any questions about this transaction, please contact our support team.</p>
                            </div>
                        </div>
                    ) : (
                        <p>Loading transaction details...</p>
                    )
                }
                size="md"
            />
            {/* Onboarding Popup */}
            <Popup
                isOpen={isOnboardingPopupOpen}
                onClose={() => setIsOnboardingPopupOpen(false)}
                title="Need to on-Board on stripe"
                canDismiss
                icon={<FaCircleExclamation color="#D72828" size={110} className="my-[5rem]" />}
                content={
                    <div className="text-[1.4rem] font-[400] text-center">
                        Click On-Board to Complete your On-Boarding
                    </div>
                }
                size="sm"
                primaryButton={{
                    text: 'On-Board',
                    onClick: () => {
                        dispatch(stripeOnboarding({
                            "successUrl": `${stripe_onboarding_callback}success`,
                            "cancelUrl": `${stripe_onboarding_callback}failed`
                        }, (status, response, message) => {
                            if (status == 200) {
                                setIsOnboardingPopupOpen(false);
                                window.open(response?.onboardingUrl, "_self");
                            } else if (status) {
                                Toast(message, "error");
                            }
                        }))
                    },
                }}
                secondaryButton={{
                    text: 'Cancel',
                    onClick: () => {
                        setIsOnboardingPopupOpen(false);
                    },
                }}
            />
            <Footer />

        </div>
    )
}

export default InfluencerWalletAndTransactions
